import React, { useEffect, useState } from 'react';
import { useParams } from '../../../../../../services/routing/useRouteInfo';
import { SelectQuery } from '../../../../../shared/inputs/selectQuery';
import { FormMode, FormView } from '../../../../../shared/view/form';
import { NoteCard } from '../../../../../shared/cards/noteCard';
import { usePlural } from '../../../../../../services/hooks/usePlural';

import style from './campaignAdhocTemplateForm.module.css'


export const CampaignAdhocTemplateForm = () => {

    let { id } = useParams();
    const { length } = usePlural(id, ',');

    return <>
        <FormView
            ids={id?.split(',').map(i => parseInt(i ?? ''))}
            resourceName={length > 1 ? 'Campaign Templates' : 'Campaign Template'}
            nameFunction={r => r?.name}
            restEndpoint='/communications/campaigns/adhocs/templates'
            listLocation='/communications/campaigns/templates'
            formMode={length === 0 ? FormMode.Add : FormMode.Edit}
            processData={(d) => {
                d.active ??= true;
                return d;
            }}
            format={{
                ...(length > 0 ? {
                    'active': {
                        type: 'switch',
                        default: true,
                        forChangeLog: v => v.active ? 'Active' : 'Inactive',
                        switchData: length > 1 ?  [
                            {
                                label: 'Ignored',
                                value: null
                            },
                            {
                                label: 'Active',
                                value: true
                            },
                            {
                                label: 'Inactive',
                                value: false
                            }
                        ] : [
                            {
                                label: 'Active',
                                value: true
                            },
                            {
                                label: 'Inactive',
                                value: false
                            }
                        ]
                    },
                } : {}),
                'name': {
                    max: 50,
                },
                ...(length === 0 ? {
                    'message': {
                        max: 4000,
                        rows: 4,
                        type: 'textarea',
                    },
                    'outboundCallerIdId': {
                        label: 'Outbound Caller ID',
                        max: 50,
                        type: 'custom',
                        forChangeLog: v => v._outboundCallerId
                            ? (v._outboundCallerId.name + ' ' + v._outboundCallerId.contact)
                            : v.outboundCallerId
                                ? (v.outboundCallerId.name + ' ' + v.outboundCallerId.contact)
                                : '?',
                        element: ({setFieldValue, isSubmitting, data, key, values}) => <>
                            <OutboundCallerIdInput
                                setFieldValue={setFieldValue}
                                isSubmitting={isSubmitting}
                                data={data}
                                len={length}
                                name={key}
                            />

                            {((values['_outboundCallerId'] ?? data.outboundCallerId)?.note) && (
                                <NoteCard
                                    title='Caller ID Note'
                                    editButton={false}
                                    deleteButton={false}
                                    thin={true}
                                >{(values['_outboundCallerId'] ?? data.outboundCallerId)?.note}</NoteCard>
                            )}
                        </>
                    },
                } : {}),
                // Only edit notes individually
                ...(length <= 1 ? {
                    'note': {
                        max: 4000,
                        rows: 4,
                        type: 'textarea',
                        required: false,
                    },
                } : {}),
            }}
        />
    </>
}

const OutboundCallerIdInput = ({setFieldValue, isSubmitting, data, name, len}) => {
    const [value, setValue] = useState(len === 1 ?
            data[0]?.outboundCallerId ?? {}
            : len > 1 ? {id: null, name: '', contact: '', channelId: null, note: ''}
            : {}
        );

    useEffect(() => {
        // Update the id on the key field
        setFieldValue(name, value?.id ?? null)

        // Define the whole object to a temporary field
        if (!((value?.id ?? null) === null && value?.name === ''))
            setFieldValue('_outboundCallerId', value)
    }, [value]);
    
    return <SelectQuery
        value={value}
        onChange={setValue}
        placeholder={len > 1 && (value?.id ?? null) === null ? '—' : undefined}
        pluralResourceName='Outbound Caller IDs'
        restEndpoint='/communications/campaigns/outboundCallerIds'
        disabled={isSubmitting}
        allowEmpty={true}
        nameFunction={(d) => (d.name && d.contact) ? `${d.name} (${d.contact})` : ''}
    />
}